import styled from "styled-components";

export const PaymentInBatchesPage = styled.div`
  width: calc(100vw - 138.67px);
  min-height: 100vh;
  padding-top: 44px; 
  display: flex;
  position: absolute;

  .page-title {
    color: #005FAE;
    font-size: 18px;
    font-weight: 400;
    line-height: 24px;
    width: fit-content;
  }
`;

export const PaymentInBatchesContainer = styled.div`
  background-color: #FAFAFA;
  width: 100%;
  padding: 36px;
  
  .container {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 25px;
    border-radius: 12px;
    border: 1px solid #E5E4E5;
    background-color: #fff;
    box-shadow: 2px 2px 6px 2px rgba(0, 0, 0, 0.2);

    .loading-text {
      display: flex;
      align-items: center;
      justify-content: start;
      gap: 5px;
    }

  }

  .debts-table-list {
    margin-top: 25px;
    display: flex;
    align-items: center;
    justify-content: center;

    div.contact-and-ticket {
      display: flex;
      gap: 15px;
      width: 100%;
      max-width: 1200px;
      
      > div {
        width: 100%;
      }
    }
  }
`;

export const PaymentMethodContainer = styled.div`
  width: 480px;
  background-color: #fff;
  border-left: 1px solid #E5E4E5;
  display: flex;
  flex-direction: column;
  gap: 8px;

  .method-title {
    padding: 25px 0 0 20px;
  }
`;

export const LoadingPaymentMenthods = styled.div`
  display: flex;
  position: relative;
  top: 180px;

  .content {
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    text-align: center;

    p {
      color: #616161;
      font-size: 14px;
      font-weight: 300;
      line-height: 20px;
    }
  }
`;

export const ContactContainer = styled.div`
  background-color: #FFF;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.3);
  height: fit-content;

  h3 {
    font-size: 18px;
  }

  .content {
    display: flex;
    width: 100%;
    margin-top: 5px;

    > div {
      width: 100%;

      .item {
        margin-top: 12px;
        strong, span {
          display: block;
          font-size: 14px;
        }
      }

      .icons {
        display: flex;
        gap: 10px;

        svg {
          cursor: pointer;
          color: #F58220;
          font-size: 29px;
        }
      }
    }    
  }
`;

export const CouponContainer = styled.div<{ valid: boolean | undefined, open: boolean }>`
  .coupon-container {
    background-color: #FFF;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.3);
    height: fit-content;
  
    .header-togg{
      display: flex;
      gap: 10px;
      justify-content: space-between;
  
      .main-togg {
        cursor: pointer;
        font-size: 16px;
        gap: 8px;
        display: flex;
        align-items: center;
        margin-bottom: ${props => props.open ? "15px" : "0"};
    
        &:hover {
          opacity: 0.8;
        }
    
        span {
          text-decoration: underline;
        }
        
        > svg {
          color: #F58220;
        }
      }
    }
  
    .available-status {
      color: #FFF;
      background-color: #F58220;
      margin-bottom: 15px;
      width: fit-content;
      padding: 10px 12px;
      border-radius: 12px;
      font-size: 14px;
      display: flex;
      align-items: center;
      gap: 5px;
      cursor: pointer;
  
      &:hover {
        opacity: 0.85;
      }
    }
  
    .content {
  
      .descount-values {
        div {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: #4D4C4D;
          font-size: 16px;
          margin-top: 12px;
        }
      }
  
      .ticket-input {
        width: 100%;
        
        input {
          font-size: 14px;
        }
  
        label {
          display: none;
        }
        
        svg {
          font-size: 14px;
          color: ${props => props.valid ? "#F58220" : "#FC0027"};
        }
  
      }
    }
  }

  div.actions {
    margin-top: 25px;
    width: 100%;
    display: flex;
    justify-content: end;
    gap: 30px;

    .new-consult {
      color: #F58220;
      font-size: 16px;
      display: flex;
      align-items: center;
      gap: 8px;
      cursor: pointer;

      span {
        text-decoration: underline;
        font-weight: 500;
      }

      &:hover {
        opacity: 0.8;
      }
    }

    .submit-btn {
      color: #FFF;
      background-color: #F58220;
      font-size: 16px;
      display: flex;
      align-items: center;
      padding: 13px;
      border-radius: 12px;
      cursor: pointer;

      &:hover {
        opacity: 0.8;
      }

      &.disabled {
        opacity: 0.8;
        cursor: not-allowed;
        background-color: grey;
      }

      svg {
        margin-left: 8px;
      }
    }
  }
`;